import React, {useEffect, useState} from "react";
import "./NewBlogs.scss";
import image1 from "../../../../assets/images/blog6-1.png";
import image2 from "../../../../assets/images/blog6-2.png";
import image3 from "../../../../assets/images/blog6-3.png";
import image4 from "../../../../assets/images/blog6-4.png";
import image5 from "../../../../assets/images/blog6-5.png";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";

const Blog6 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);

  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">
          Weekly Market Outlook <br /> February 17, 2025
        </h2>
      </div>
      <div className="blogContentnew">
        <div className="subHeader">
          <p className="highlightedBoldText">Will Trump’s Energy Play Shake Up Markets?</p>

          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">Markets on the Move: Europe’s Defense Surge, Trump’s Oil Play, and a Shaky Dollar</p>
              <p>
                DAX is up
                <span className="highlightedText"> 15% YTD</span> as German elections approach, while European bond yields are surging on expectations of a{" "}
                <span className="highlightedText">$3 trillion defense spending package.</span> Trump’s refusal to fund NATO unless Europe steps up creates a vacuum, but it’s a strategic
                masterstroke—keeping demand for U.S. defense goods high without spending American tax dollars
                <span className="highlightedText"> Markets are watching defense stocks closely.</span>
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image1}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">Trump’s Oil Gamble: The Big Question—Pump or Dump?</p>

              <p>
                Trump’s apparent deal with
                <span className="highlightedText"> Putin revolves around oil</span>--a strategy to sideline Iranian supply while
                <span className="highlightedText"> $pressuring Saudi Arabia and Russia</span> to get crude below $60. Why? Because U.S. fracking isn’t profitable at those levels
              </p>
              <p>
                With oil in
                <span className="highlightedText"> backwardation </span>(futures pricing lower than spot), the market is screaming
                <span className="highlightedText"> "Drill, Baby, Drill”</span> to get crude below $60. Why? Because U.S. fracking isn’t profitable at those levels
                <span className="highlightedText"> central bank rate cuts in jeopardy.</span>
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">Is Trump Top Cat or Officer Dibble?</p>

              <p>
                Markets aren’t sure whether Trump is
                <span className="highlightedText"> the cunning leader (Top Cat) or the law-abiding enforcer (Dibble).</span> The expectation? Big talk, but
                <span className="highlightedText"> less action.</span> The real test comes
                <span className="highlightedText"> April 1st, </span>
                when details on reciprocal tariffs drop. Until then, global equities are rallying on dollar weakness and lower risk premiums as conflicts get sorted.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader pointersWrapper">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <h2 className="highlightedBoldText">Technical & Sentiment Breakdown: What’s Next for the Dollar and Equities?</h2>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">Bond Yields Rising</h2>
                  <p>
                    Markets are repricing expectations as Europe prepares to issue potential <span className="highlightedText">Euro-Bonds</span> for defense spending.
                  </p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText">Gold Pauses at ATHs ($3,000 in sight?):</h2>
                  <p>A 2% pullback before a grind higher? War premiums may be fading.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText">Intel Posts Best Week Since 1982:</h2>
                  <p>
                    Signs of life beyond the <span className="highlightedText">Mag7?</span>
                  </p>
                </li>
              </ul>
            </div>

            <div className="relatedImg">
              <img
                src={image2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <h2 className="highlightedBoldText">Last Week’s Market Recap</h2>

              <ul className="pointersSection">
                <li className="technicalPointer">
                  <h2 className="pointersText">U.S. Inflation Surprise:</h2>
                  <p>
                    CPI and PPI came in hotter than expected, initially<span className="highlightedText"> pushing bond yields up</span> and rate cut expectations down. But digging into the detail
                    <span className="highlightedText"> saw lack of inflation in the things that feed the FED’s preferred PCE inflation measure and saw US yields fall back again</span>
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">Tech’s Massive Comeback:</h2>
                  <p>
                    Hedge funds flipped from underweight to aggressively buying
                    <span className="highlightedText"> semiconductors and software.</span>
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">Retail Traders Jumping In:</h2>
                  <p>
                    VIX remains low, indicating<span className="highlightedText"> Wall of Worry</span> rally potential.
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">Defense Stocks Surge In:</h2>
                  <p>
                    <span className="highlightedText">Rheinmetall, Saab, BAE</span> among the biggest winners. Don’t forget potential for Industrial rebuild in Ukraine...that could
                    <span className="highlightedText"> boost a sector which is 11% of Europe’s markets</span>
                  </p>
                </li>
              </ul>
            </div>

            <div className="relatedImg">
              <img
                src={image3}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image3)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <h2 className="highlightedBoldText">The Week Ahead: Key Events to Watch</h2>

              <ul className="pointersSection">
                <li className="technicalPointer">
                  <h2 className="pointersText">1. Feb 18th:</h2>
                  <p>
                    <span className="highlightedText">RBA rates decision</span>
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">2. Feb 19th:</h2>
                  <p>
                    <span className="highlightedText">FOMC minutes</span>
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">3. Feb 20th:</h2>
                  <p>
                    <span className="highlightedText">U.S. Initial Jobless Claims & Philly Fed Index</span>
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">4. Feb 21st:</h2>
                  <p>
                    <span className="highlightedText">Global PMI Data & Michigan Inflation Expectations</span>
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">5. Feb 23rd:</h2>
                  <p>
                    <span className="highlightedText">German Elections—Market implications on Euro & DAX</span>
                  </p>
                </li>
                <li className="technicalPointer">
                  <h2 className="pointersText">6. Earnings to Watch:</h2>
                  <p>HSBC, Rio Tinto, Walmart, Alibaba, Booking.com</p>
                </li>
              </ul>
            </div>

            <div className="relatedImg">
              <img
                src={image4}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image4)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <h2 className="highlightedBoldText">Actionable Takeaways: Where Are the Big Trades?</h2>
          <div className="technicalPointer pointersSection">
            <h2 className="pointersText">🚀 Equities: </h2>
            <p>If defense spending pushes forward, European stocks could see more upside.</p>
          </div>
          <div className="technicalPointer pointersSection">
            <h2 className="pointersText">💰 Commodities: </h2>
            <p>
              {" "}
              Oil volatility is a trader’s paradise—watch for <span className="highlightedText">key support levels</span> near pre-Ukraine war prices.
            </p>
          </div>
          <div className="technicalPointer pointersSection">
            <h2 className="pointersText">📉 Bonds: </h2>
            <p>Rising yields are pressuring risk assets, but if inflation surprises lower, expect a sharp reversal.</p>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Final Thought: Are Markets Too Complacent?</h2>

              <p>
                With tariffs looming, Trump’s energy maneuvers in motion, and global defense budgets <span className="highlightedText">soaring, </span> are traders{" "}
                <span className="highlightedText"> too comfortable</span> with the current low-volatility environment?{" "}
                <span className="highlightedText">This could be the biggest Wall of Worry rally yet.</span> Stay nimble, watch for Trump headlines, and don’t ignore the bond market’s message.
              </p>
              <p>AtlantaGDP Now came in at 2.3% from 2.9% on Friday reflecting lower inventories and retail sales both affecting economic activity…keep looking at the data for signals</p>
            </div>
            <div className="relatedImg">
              <img
                src={image5}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image5)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
          <p>#Trading #MacroTrends #WeeklyMarketOutlook #OilPolitics #EquitiesForecast</p>
        </div>
      </div>{" "}
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog6;
